import { io } from "socket.io-client";

const ip = `http://${localStorage.getItem("localIP")}:8000`;


export const socket = io.connect(ip, {
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 3,
  transports: ["websocket", "polling"],
});
